import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { JudgeStateModuleName } from '@/store/modules/modules'

export class JudgeStateViewModel {
  private store = useStore()

  judgeId: ComputedRef<string> = computed(() => this.store.getters[`${JudgeStateModuleName}/judgeId`])
  isTestLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${JudgeStateModuleName}/isTestLoading`])
  isJudgeLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${JudgeStateModuleName}/isJudgeLoading`])
  isTestNotificationLoading: ComputedRef<boolean> = computed(
    () => this.store.getters[`${JudgeStateModuleName}/isTestNotificationLoading`]
  )
  isJudgeNotificationLoading: ComputedRef<boolean> = computed(
    () => this.store.getters[`${JudgeStateModuleName}/isJudgeNotificationLoading`]
  )
  judgeRecord: ComputedRef<JudgeRecord | null> = computed(
    () => this.store.getters[`${JudgeStateModuleName}/judgeRecord`]
  )
  testInput: ComputedRef<string> = computed(() => this.store.getters[`${JudgeStateModuleName}/testInput`])
  testOutput: ComputedRef<string> = computed(() => this.store.getters[`${JudgeStateModuleName}/testOutput`])

  setJudgeId(judgeId: string): void {
    this.store.commit(`${JudgeStateModuleName}/setJudgeId`, judgeId)
  }

  setIsTestLoading(isLoading: boolean): void {
    this.store.commit(`${JudgeStateModuleName}/setIsTestLoading`, isLoading)
  }

  setIsJudgeLoading(isLoading: boolean): void {
    this.store.commit(`${JudgeStateModuleName}/setIsJudgeLoading`, isLoading)
  }

  setIsTestNotificationLoading(isLoading: boolean): void {
    this.store.commit(`${JudgeStateModuleName}/setIsTestNotificationLoading`, isLoading)
  }

  setIsJudgeNotificationLoading(isLoading: boolean): void {
    this.store.commit(`${JudgeStateModuleName}/setIsJudgeNotificationLoading`, isLoading)
  }

  setJudgeRecord(judgeRecord: JudgeRecord | null): void {
    this.store.commit(`${JudgeStateModuleName}/setJudgeRecord`, judgeRecord)
  }

  setTestInput(testInput: string): void {
    this.store.commit(`${JudgeStateModuleName}/setTestInput`, testInput)
  }

  setTestOutput(testOutput: string): void {
    this.store.commit(`${JudgeStateModuleName}/setTestOutput`, testOutput)
  }
}
